import { render, staticRenderFns } from "./BrowserNotSupported.vue?vue&type=template&id=723052a0&scoped=true&"
import script from "./BrowserNotSupported.vue?vue&type=script&lang=ts&"
export * from "./BrowserNotSupported.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723052a0",
  null
  
)

export default component.exports